import React from "react"
import { getIn } from "formik"

const TextField = ({ field, form: { touched, errors }, ...props }) => {
  let status = "default"
  if (getIn(touched, field.name) && getIn(errors, field.name)) {
    status = "has-error"
  } else if (
    getIn(touched, field.name) &&
    field.value &&
    !getIn(errors, field.name)
  ) {
    status = "is-fixed"
  }
  return (
    <div className={`TextField ${status}`}>
      <input type="text" {...field} {...props} />
      {getIn(touched, field.name) &&
        getIn(errors, field.name) && (
          <div className="error-message">{getIn(errors, field.name)}</div>
        )}
    </div>
  )
}

export default TextField
